import * as React from "react";

function Alert({ className = "", variant = "default", ...props }) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={`alert alert-${variant} ${className}`}
      {...props}
    />
  );
}

function AlertTitle({ className = "", ...props }) {
  return (
    <div
      data-slot="alert-title"
      className={`alert-title ${className}`}
      {...props}
    />
  );
}

function AlertDescription({ className = "", ...props }) {
  return (
    <div
      data-slot="alert-description"
      className={`alert-description ${className}`}
      {...props}
    />
  );
}

export { Alert, AlertTitle, AlertDescription };
